import { Loader, TextInput } from "@mantine/core";
import IconCopy from "@src/assets/icons/tabler/copy.svg?react";
import { NativeLikeTooltip as Tooltip } from "@src/components/ui/native-like-tooltip";
import clsx from "clsx";

type LinkInputWithCopyProps = {
	value: string | null;
	placeholder: string;
	disabled: boolean;
	isLoading: boolean;
	isActive: boolean;
	tooltipOpen: boolean;
	onTooltipTrigger: () => void;
};

export function LinkInputWithCopy({
	value,
	placeholder,
	disabled,
	isLoading,
	isActive,
	tooltipOpen,
	onTooltipTrigger,
}: LinkInputWithCopyProps) {
	const canCopy = Boolean(value && isActive && !isLoading);
	const displayValue = isLoading ? "" : (value ?? "");

	return (
		<TextInput
			size="md"
			radius="md"
			classNames={{
				input: clsx(
					"focus:border-brand-primary bg-surface-subtle text-text-primary",
					"placeholder:text-text-muted",
					!isActive && "border-dashed",
				),
			}}
			rightSectionPointerEvents="all"
			leftSection={isLoading && <Loader size="xs" color="gray" />}
			rightSection={
				<Tooltip
					zIndex={9999}
					label="Link Copied"
					openDelay={500}
					opened={tooltipOpen}
					withArrow
				>
					<div className="flex items-center pr-2">
						<div
							className={clsx(
								"p-2 rounded-md transition-all duration-200",
								canCopy
									? "cursor-pointer text-brand-primary hover:bg-brand-primary-soft hover:scale-110 active:scale-95"
									: "pointer-events-none text-muted",
							)}
							onClick={() => {
								if (!canCopy || !value) return;
								navigator.clipboard.writeText(value);
								onTooltipTrigger();
							}}
						>
							<IconCopy className="w-4 h-4" />
						</div>
					</div>
				</Tooltip>
			}
			value={displayValue}
			readOnly
			placeholder={placeholder}
			disabled={disabled}
		/>
	);
}
